/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import React from 'react';
import { Package, Barcode, Tags, Server } from 'lucide-react';

export const ProductsInventory = () => (
  <div className="space-y-8">
    <p className="text-lg text-stone-600 dark:text-stone-300 leading-relaxed font-medium">
      Merchants can manage their entire product catalog directly from the GhostPay dashboard. This system is designed to be the single source of truth for all sales channels.
    </p>
    <div className="grid gap-6 md:grid-cols-2">
        {[
            { icon: Package, title: "Product Management", desc: "Add, edit, and remove products, including details like name, price, description, and images." },
            { icon: Barcode, title: "SKU and Inventory", desc: "Assign unique SKUs and track stock levels. Inventory is automatically decremented upon a confirmed on-chain sale." },
            { icon: Tags, title: "Categories", desc: "Organize products into categories for easier management and discovery in the Point-of-Sale interface." },
            { icon: Server, title: "API Access", desc: "All product and inventory data is accessible via the API, allowing for integration with e-commerce sites." }
        ].map((item, i) => (
            <div key={i} className="flex gap-5 p-6 bg-white dark:bg-white/5 rounded-xl border border-stone-200 dark:border-white/10 hover:border-nobel-gold/50 dark:hover:border-nobel-gold/50 transition-colors">
                <div className="text-nobel-gold flex-shrink-0 mt-1">
                    <item.icon size={28} />
                </div>
                <div>
                    <h4 className="font-bold text-stone-900 dark:text-white text-lg mb-2">{item.title}</h4>
                    <p className="text-stone-600 dark:text-stone-400 text-sm leading-relaxed">{item.desc}</p>
                </div>
            </div>
        ))}
    </div>
  </div>
);